import React from 'react';

import { Skeleton } from '@/components/ui/skeleton';

interface ChartBodySkeletonProps {
  height?: number;
}

export const ChartBodySkeleton: React.FC<ChartBodySkeletonProps> = ({ height = 220 }) => (
  <div className="flex flex-col gap-3" role="status" aria-busy="true" aria-label="Loading chart">
    <Skeleton className="h-4 w-32" />
    <Skeleton className="w-full" style={{ height }} />
    <div className="flex justify-center gap-4">
      <Skeleton className="h-3 w-20" />
      <Skeleton className="h-3 w-24" />
      <Skeleton className="h-3 w-20" />
    </div>
  </div>
);

interface ChartEmptyStateProps {
  height?: number;
  message?: string;
}

export const ChartEmptyState: React.FC<ChartEmptyStateProps> = ({
  height = 220,
  message = 'No data for the selected period.',
}) => (
  <div
    className="flex items-center justify-center rounded-md border border-dashed border-border/70 bg-muted/20 px-4 text-center text-sm text-muted-foreground"
    style={{ minHeight: height }}
  >
    {message}
  </div>
);
